import API from './core/Services/API/api'
import store from './core/redux/store'
import { addLocation } from './core/redux/actions/location'

export const getLocation = async (): Promise<void> => {
    const list = await API.locations.list()
    store.dispatch(addLocation(list))
}
